import { alpha } from '@mui/material';

/**
 * A slim, rounded scrollbar for scrolling panels (kanban lanes, side lists).
 * The thumb stays invisible until the panel is hovered, so long lists read
 * as clean surfaces. Spread into an `sx` prop:
 *
 *   <Box sx={{ overflowY: 'auto', ...thinScrollbar(theme.palette.text.primary) }}>
 */
export const thinScrollbar = (color: string) => ({
  scrollbarWidth: 'thin' as const,
  scrollbarColor: 'transparent transparent',
  '&:hover': { scrollbarColor: `${alpha(color, 0.25)} transparent` },
  '&::-webkit-scrollbar': { width: 6, height: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { background: 'transparent', borderRadius: 3 },
  '&:hover::-webkit-scrollbar-thumb': { background: alpha(color, 0.25) },
  '&::-webkit-scrollbar-thumb:hover': { background: alpha(color, 0.45) },
});
